import React from 'react';
import { graphql } from 'gatsby';

import Page from '../components/global/page';
import PrivacyTemplate from '../templates/privacy-template';

export default ({ data }) => {
	return (
		<Page title={data.copy.title}>
			<PrivacyTemplate data={data.copy} />
		</Page>
	);
};

export const PrivacyQuery = graphql`
	{
		copy: pagesJson(page: { eq: "covid-19" }) {
			title
			mdContent
		}
	}
`;
